/// <reference path="../../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class StartContractModalController {
        public static $inject: string[] = [
            '$mdMedia',
            '$mdDialog',
            '$mobilityCompanyAuthentication',
            '$dealerwareInternationalizationDateFormats',
            '$filter'
        ];

        private isMetric: boolean;
        public contract: any;

        constructor(public $mdMedia: any,
                    public $mdDialog: any,
                    public $mobilityCompanyAuthentication: any,
                    public $filter: any) {
                      this.isMetric = $mobilityCompanyAuthentication.location.settings.metric;
                    }

        public get useFullScreen() {
            return (this.$mdMedia('xs') || this.$mdMedia('sm'));
        }

        public open() {
            this.$mdDialog.show({
                controller: DialogController,
                locals: { contract: this.contract, isMetric: this.isMetric },
                templateUrl: '/components/contract/details/start/start_contract_modal_directive.html',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
                fullscreen: this.useFullScreen
            });

            function DialogController($scope: any,
                                      $rootScope: any,
                                      $mdDialog: any,
                                      $dealerwareLoading: any,
                                      $dealerwareNotification: any,
                                      $mobilityCompanyAuthentication: any,
                                      DataUtils: any,
                                      contract: any,
                                      isMetric: boolean,
                                      RoundValues: object,
                                      $dealerwareInternationalizationDateFormats: any) {
                var location = $mobilityCompanyAuthentication.location;
                $scope.internationalization = $dealerwareInternationalizationDateFormats.datePickerFormat();
                $scope.times = $dealerwareInternationalizationDateFormats.getAvailablesTimesFormat();

                $scope.contract = contract;
                $scope.pickupDate = displayPickupDate();
                $scope.pickupTime = displayPickupTime();
                $scope.originalFuel = undefined;
                $scope.fuel = undefined;
                $scope.hasFuelChanged = false;
                $scope.mileage = undefined;
                $scope.carLastUpdated = undefined;
                $scope.carId = undefined;
                $scope.carSelected = false;

                $scope.fuelLevels = [
                    { display: 'Full', value: 100 },
                    { display: '15/16', value: 93.75 },
                    { display: '7/8', value: 87.5 },
                    { display: '13/16', value: 81.25 },
                    { display: '3/4', value: 75 },
                    { display: '11/16', value: 68.75 },
                    { display: '5/8', value: 62.5 },
                    { display: '9/16', value: 56.25 },
                    { display: '1/2', value: 50 },
                    { display: '7/16', value: 43.75 },
                    { display: '3/8', value: 37.5 },
                    { display: '5/16', value: 31.25 },
                    { display: '1/4', value: 25 },
                    { display: '3/16', value: 18.75 },
                    { display: '1/8', value: 12.5 },
                    { display: '1/16', value: 6.25 },
                    { display: 'Empty', value: 0 }
                ];
  
                function displayPickupDate(){
                    if($scope.contract.contractDetails.data.pickup_display === undefined){
                        return moment().toDate();
                    }
                    return $scope.contract.contractDetails.data.pickup_display;
                }
  
                function displayPickupTime(){
                    if($scope.contract.contractDetails.data.local_pickup_time === undefined){
                        return defaultPickupTime();
                    }
                    const t = $scope.times.filter(time => time.value === $scope.contract.contractDetails.data.local_pickup_time.slice(0,-3));
                    return t[0];
                }
  
                function defaultPickupTime() {
                    var now = moment().startOf('minute');

                    if (now.minute() < 30) {
                        now.add(30 - now.minute(), 'minutes');
                    } else {
                        now.add(1, 'hour');
                        now.subtract(now.minute(), 'minutes');
                    }

                    return now.format('HH:mm:ss');
                }

                function lastReportedFuel(car: any, fuel?: number) {
                    const capacityInGallons = $rootScope.convertLitersToGallons(car.fuel_capacity);
                    const reportedFuel = fuel || car.fuel;

                    return RoundValues.fuelPercentage(reportedFuel, capacityInGallons, car.connected);
                }

                function originalFuelPercentage(fuel: number, capacity: number) {
                    var capacityInGallons = $rootScope.convertLitersToGallons(capacity);
                    return parseFloat((fuel / capacityInGallons * 100).toFixed(2));
                }

                $rootScope.$broadcast("$startContractOpened", {});

                $scope.cancel = function() {
                    $mdDialog.hide();
                };

                $scope.setDataFromCarModel = function(car: any) {
                    var mileage = isMetric ? car.data.mileage_in_km : car.data.mileage;

                    $scope.mileage = parseInt(mileage, 10);
                    $scope.fuel = lastReportedFuel(car.data);
                    $scope.carLastUpdated = DataUtils.getInstance().formatTimestampSimple(
                        car.data.updated_at,
                        location.time_zone_name
                    );

                    if (!car.data.connected) {
                        $scope.originalFuel = originalFuelPercentage(car.data.fuel, car.data.fuel_capacity);
                    }
                };

                $scope.selectCar = function(car: any) {
                    $scope.carSelected = true;
                    $scope.carId = car.data.id;

                    if (location.has_ccs && car.data.connected) {
                        var loader = $dealerwareLoading.show('Please Wait...');
                        car.$scanCCD({ promise: true }).then(
                            (scans: any) => {
                                var lastScan = scans.data[0];
                                var mileage = isMetric ? lastScan.mileage_in_km : lastScan.mileage;

                                $scope.mileage = parseInt(mileage, 10);
                                $scope.originalFuel = originalFuelPercentage(lastScan.fuel, car.data.fuel_capacity);
                                $scope.fuel = lastReportedFuel(car.data, lastScan.fuel);
                                $scope.carLastUpdated = DataUtils.getInstance().formatTimestampSimple(
                                    lastScan.created_at,
                                    location.time_zone_name
                                );
                                loader.close();
                            },
                            () => {
                                $scope.setDataFromCarModel(car);
                                loader.close();
                            }
                        );
                    } else {
                        $scope.setDataFromCarModel(car);
                    }
                };

                $scope.changeFuel = function() {
                    $scope.hasFuelChanged = true;
                }

                $scope.startContract = function() {
                    var loader = $dealerwareLoading.show('Starting...');
                    var fuel = !$scope.hasFuelChanged && $scope.originalFuel
                        ? $scope.originalFuel
                        : $scope.fuel;

                    $scope.contract.contractDetails.$start({
                        promise: true,
                        params: {
                            location_id: $scope.contract.locationId,
                            car_id: $scope.carId,
                            actual_pickup_date: moment($scope.pickupDate).format('YYYY-MM-DD'),
                            actual_pickup_time: $scope.pickupTime.value,
                            fuel: fuel,
                            mileage: $scope.mileage,
                            manual_reading: true,
                            unlocked: true
                        }
                    }).then(
                        function() {
                            $scope.contract.loadContractDetails().finally(
                                function() {
                                    loader.close();
                                    $mdDialog.hide();
                                }
                            );
                        },
                        function(response: any) {
                            loader.close();
                            $dealerwareNotification.apiError(response);
                        }
                    );
                };
            }
        }
    }

    getDealerwareWebComponentsModule().controller('StartContractModalController', StartContractModalController);


    export class StartContractModalDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public controller       : any       =   'StartContractModalController';
        public controllerAs     : string    =   'startContractModalController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   { contract: '=' };
        public transclude       : boolean   =   false;
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            elem    :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            elem.bind('click', function() {
                ctrls.open();
            });
        }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareStartContractModal",() => new StartContractModalDirective());
}
